module.exports = __webpack_public_path__ + "static/img/pop_bg_right.19b284c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dashboard/pop_bg_right.png
// module id = to5c
// module chunks = 2